import { combineReducers, configureStore } from "@reduxjs/toolkit";
import homeSlice from "./homeSlice";

const createReducer = () => (state, action) => {
  const combinedReducer = combineReducers({
    home: homeSlice,
  });

  return combinedReducer(state, action);
};

const middlewares = [];
if (process.env.NODE_ENV === "development") {
  const { createLogger } = require(`redux-logger`);
  const logger = createLogger({
    collapsed: (getState, action, logEntry) => !logEntry.error,
  });

  middlewares.push(logger);
}

const store = configureStore({
  reducer: createReducer(),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(middlewares),
  devTools: process.env.NODE_ENV === "development",
});

if (module.hot) {
  // Enable Webpack hot module replacement for reducers
  module.hot.accept("./index.js", () => {
    store.replaceReducer(createReducer());
  });
}

export default store;
